<template>
  <div class="page-header-index-wide" v-if="roleLimitre">
    <a-row :gutter="24">
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px', width: '33%' }">
        <chart-card :loading="loading" title="销售预约量" :total="sellPredictQuantity">
          <a-tooltip title="指标说明" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <trend flag="up" style="margin-right: 16px">
              <span slot="term">周同比</span>
              12%
            </trend>
            <trend flag="down">
              <span slot="term">日同比</span>
              11%
            </trend>

            <a-date-picker @change="onChanged" />
          </div>

          <template
            slot="footer"
          >日销售预约量<span>{{ todaySellPredictQuantity }}吨</span></template
          >
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px', width: '33%' }">
        <chart-card :loading="loading" title="销售提货量" :total="sellQuantity | NumberFormat">
          <a-tooltip title="指标说明" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <mini-area />
          </div>
          <template
            slot="footer"
          >日销售提货量<span> {{ todaySellQuantity | NumberFormat }}吨</span></template
          >
        </chart-card>
      </a-col>
      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px', width: '33%' }" v-if="false">
        <chart-card :loading="loading" title="采购重量" :total="purchaseQuantity | NumberFormat">
          <a-tooltip title="指标说明" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <mini-bar />
          </div>
          <template
            slot="footer"
          >日采购重量 <span>{{ todayPurchaseQuantity }}</span></template
          >
        </chart-card>
      </a-col>

      <a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px', width: '33%' }">
        <DatePicker onChange="{onChange}" />
      </a-col>

      <!--<a-col :sm="24" :md="12" :xl="6" :style="{ marginBottom: '24px' }">
        <chart-card :loading="loading" title="运营活动效果" total="78%">
          <a-tooltip title="指标说明" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div>
            <mini-progress color="rgb(19, 194, 194)" :target="80" :percentage="78" height="8px" />
          </div>
          <template slot="footer">
            <trend flag="down" style="margin-right: 16px;">
              <span slot="term">同周比</span>
              12%
            </trend>
            <trend flag="up">
              <span slot="term">日环比</span>
              80%
            </trend>
          </template>
        </chart-card>
      </a-col>-->
    </a-row>
    <a-card :loading="loading" :bordered="false" :body-style="{ padding: '0' }">
      <div class="salesCard">
        <a-tabs default-active-key="1" size="large" :tab-bar-style="{ marginBottom: '24px', paddingLeft: '16px' }">
          <a-tab-pane tab="日料口出料量" loading="true" key="1">
            <a-row>
              <schart
                :canvasId="canvasId2"
                style="width: 1215px; height: 398px; fontsize: '3px'"
                :type="type"
                :width="width"
                :height="height"
                :data="portData"
              >
              </schart>
            </a-row>
          </a-tab-pane>

          <a-tab-pane tab="销售提货量" key="2">
            <a-row>
              <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">
                <schart
                  :canvasId="canvasId"
                  style="width: 1215px; height: 398px; fontsize: '3px'"
                  :type="type"
                  :width="width"
                  :height="height"
                  :data="data"
                >
                </schart>
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane tab="秤台车次" key="3">
            <a-row>
              <schart
                :canvasId="canvasId1"
                style="width: 1215px; height: 398px; fontsize: '3px'"
                :type="type"
                :width="width"
                :height="height"
                :data="vechileNumData"
              >
              </schart>
            </a-row>
          </a-tab-pane>

          <a-tab-pane tab="今日采购量" key="4" v-if="false">
            <a-row>
              <schart
                :canvasId="canvasId3"
                style="width: 1215px; height: 398px; fontsize: '3px'"
                :type="type"
                :width="width"
                :height="height"
                :data="purchaseData"
              >
              </schart>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-card>

    <!--<a-card :loading="loading" :bordered="false" :body-style="{padding: '0'}">
      <div class="salesCard">
        <a-tabs default-active-key="1" size="large" :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}">
          <div class="extra-wrapper" slot="tabBarExtraContent">
            <div class="extra-item">
              <a>今日</a>
              <a>本周</a>
              <a>本月</a>
              <a>本年</a>
            </div>
            <a-range-picker :style="{width: '256px'}" />
          </div>
          <a-tab-pane loading="true" tab="销售额" key="1">
            <a-row>
              <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">
                <bar title="销售额排行" />
              </a-col>
              <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <rank-list title="门店销售排行榜" :list="rankList"/>
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane tab="访问量" key="2">
            <a-row>
              <a-col :xl="16" :lg="12" :md="12" :sm="24" :xs="24">
                <bar title="销售额趋势" />
              </a-col>
              <a-col :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <rank-list title="门店销售排行榜" :list="rankList"/>
              </a-col>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-card>-->

    <!-- <div class="antd-pro-pages-dashboard-analysis-twoColLayout" :class="isDesktop() ? 'desktop' : ''">
       <a-row :gutter="24">
         <a-col :xl="12" :lg="24" :md="24" :sm="24" :xs="24">
           <a-card :loading="loading" :bordered="false" title="线上热门搜索" :style="{ marginTop: '24px', minHeight: '500px' }">
             <a-dropdown :trigger="['click']" placement="bottomLeft" slot="extra">
               <a class="ant-dropdown-link" href="#">
                 <a-icon type="ellipsis" />
               </a>
               <a-menu slot="overlay">
                 <a-menu-item>
                   <a href="javascript:;">操作一</a>
                 </a-menu-item>
                 <a-menu-item>
                   <a href="javascript:;">操作二</a>
                 </a-menu-item>
               </a-menu>
             </a-dropdown>
             <a-row :gutter="68">
               <a-col :xs="24" :sm="12" :style="{ marginBottom: ' 24px'}">
                 <number-info :total="12321" :sub-total="17.1">
                   <span slot="subtitle">
                     <span>搜索用户数</span>
                     <a-tooltip title="指标说明" slot="action">
                       <a-icon type="info-circle-o" :style="{ marginLeft: '8px' }" />
                     </a-tooltip>
                   </span>
                 </number-info>
                 &lt;!&ndash; miniChart &ndash;&gt;
                 <div>
                   <mini-smooth-area :style="{ height: '45px' }" :dataSource="searchUserData" :scale="searchUserScale" />
                 </div>
               </a-col>
               <a-col :xs="24" :sm="12" :style="{ marginBottom: ' 24px'}">
                 <number-info :total="2.7" :sub-total="26.2" status="down">
                   <span slot="subtitle">
                     <span>人均搜索次数</span>
                     <a-tooltip title="指标说明" slot="action">
                       <a-icon type="info-circle-o" :style="{ marginLeft: '8px' }" />
                     </a-tooltip>
                   </span>
                 </number-info>
                 &lt;!&ndash; miniChart &ndash;&gt;
                 <div>
                   <mini-smooth-area :style="{ height: '45px' }" :dataSource="searchUserData" :scale="searchUserScale" />
                 </div>
               </a-col>
             </a-row>
             <div class="ant-table-wrapper">
               <a-table
                 row-key="index"
                 size="small"
                 :columns="searchTableColumns"
                 :dataSource="searchData"
                 :pagination="{ pageSize: 5 }"
               >
                 <span slot="range" slot-scope="text, record">
                   <trend :flag="record.status === 0 ? 'up' : 'down'">
                     {{ text }}%
                   </trend>
                 </span>
               </a-table>
             </div>
           </a-card>
         </a-col>
         <a-col :xl="12" :lg="24" :md="24" :sm="24" :xs="24">
           <a-card class="antd-pro-pages-dashboard-analysis-salesCard" :loading="loading" :bordered="false" title="销售额类别占比" :style="{ marginTop: '24px', minHeight: '500px' }">
             <div slot="extra" style="height: inherit;">
               &lt;!&ndash; style="bottom: 12px;display: inline-block;" &ndash;&gt;
               <span class="dashboard-analysis-iconGroup">
                 <a-dropdown :trigger="['click']" placement="bottomLeft">
                   <a-icon type="ellipsis" class="ant-dropdown-link" />
                   <a-menu slot="overlay">
                     <a-menu-item>
                       <a href="javascript:;">操作一</a>
                     </a-menu-item>
                     <a-menu-item>
                       <a href="javascript:;">操作二</a>
                     </a-menu-item>
                   </a-menu>
                 </a-dropdown>
               </span>
               <div class="analysis-salesTypeRadio">
                 <a-radio-group defaultValue="a">
                   <a-radio-button value="a">全部渠道</a-radio-button>
                   <a-radio-button value="b">线上</a-radio-button>
                   <a-radio-button value="c">门店</a-radio-button>
                 </a-radio-group>
               </div>

             </div>
             <h4>销售额</h4>
             <div>
               &lt;!&ndash; style="width: calc(100% - 240px);" &ndash;&gt;
               <div>
                 <v-chart :force-fit="true" :height="405" :data="pieData" :scale="pieScale">
                   <v-tooltip :showTitle="false" dataKey="item*percent" />
                   <v-axis />
                   &lt;!&ndash; position="right" :offsetX="-140" &ndash;&gt;
                   <v-legend dataKey="item"/>
                   <v-pie position="percent" color="item" :vStyle="pieStyle" />
                   <v-coord type="theta" :radius="0.75" :innerRadius="0.6" />
                 </v-chart>
               </div>

             </div>
           </a-card>
         </a-col>
       </a-row>
     </div>-->
  </div>
</template>

<script>
import moment from 'moment'
import { Schart, ChartCard, MiniArea, MiniBar, MiniProgress, RankList, Bar, Trend, NumberInfo, MiniSmoothArea } from '@/components'
import { mixinDevice } from '@/utils/mixin'
import { getSellData, getSellBar, getVehicleNumBar, getPortSellBar, getPurchaseData, getTodayPurchaseBar, roleLimit } from '@/api/logistics'
// import { DatePicker, Space } from 'antd';

const rankList = []
for (let i = 0; i < 7; i++) {
  rankList.push({
    name: '白鹭岛 ' + (i + 1) + ' 号店',
    total: 1234.56 - i * 100
  })
}

const searchUserData = []
for (let i = 0; i < 7; i++) {
  searchUserData.push({
    x: moment().add(i, 'days').format('YYYY-MM-DD'),
    y: Math.ceil(Math.random() * 10)
  })
}
const searchUserScale = [
  {
    dataKey: 'x',
    alias: '时间'
  },
  {
    dataKey: 'y',
    alias: '用户数',
    min: 0,
    max: 10
  }]

const searchTableColumns = [
  {
    dataIndex: 'index',
    title: '排名',
    width: 90
  },
  {
    dataIndex: 'keyword',
    title: '搜索关键词'
  },
  {
    dataIndex: 'count',
    title: '用户数'
  },
  {
    dataIndex: 'range',
    title: '周涨幅',
    align: 'right',
    sorter: (a, b) => a.range - b.range,
    scopedSlots: { customRender: 'range' }
  }
]
const searchData = []
for (let i = 0; i < 50; i += 1) {
  searchData.push({
    index: i + 1,
    keyword: `搜索关键词-${i}`,
    count: Math.floor(Math.random() * 1000),
    range: Math.floor(Math.random() * 100),
    status: Math.floor((Math.random() * 10) % 2)
  })
}

const DataSet = require('@antv/data-set')

const sourceData = [
  { item: '家用电器', count: 32.2 },
  { item: '食用酒水', count: 21 },
  { item: '个护健康', count: 17 },
  { item: '服饰箱包', count: 13 },
  { item: '母婴产品', count: 9 },
  { item: '其他', count: 7.8 }
]

const pieScale = [{
  dataKey: 'percent',
  min: 0,
  formatter: '.0%'
}]

const dv = new DataSet.View().source(sourceData)
dv.transform({
  type: 'percent',
  field: 'count',
  dimension: 'item',
  as: 'percent'
})
const pieData = dv.rows

export default {
  name: 'Analysis',
  mixins: [mixinDevice],
  components: {
    ChartCard,
    MiniArea,
    MiniBar,
    MiniProgress,
    RankList,
    Bar,
    Trend,
    NumberInfo,
    MiniSmoothArea,
    Schart
  },
  data () {
    return {
      canvasId: 'myChart',
      canvasId1: 'myChart1',
      canvasId2: 'myChart2',
      canvasId3: 'myChart3',

      type: 'bar',

      width: 600,

      height: 500,

      /* data: [

       {name: '期刊', value: 1234},

       {name: '图书', value: 2345},

       {name: '小说', value: 2456},

       {name: '文学', value: 333},
       {name: '文学1', value: 333},
       {name: '文学2', value: 333},
       {name: '文学2', value: 333},
       {name: '文学2', value: 333},
       {name: '文学2', value: 333},
       {name: '文学2', value: 333},
       {name: '文学2', value: 333},
       {name: '文学2', value: 333},
       {name: '文学2', value: 333},
       {name: '文学2', value: 333},

       ], */
      roleLimitre: false,
      data: [],
      vechileNumData: [],
      portData: [],
      purchaseData: [],
      options: {

        title: '销售提货量'

      },
      loading: true,
      rankList,
      sellPredictQuantity: '',
      todaySellPredictQuantity: '',
      sellQuantity: '',
      todaySellQuantity: '',
      purchaseQuantity: '',
      todayPurchaseQuantity: '',

      // 搜索用户数
      searchUserData,
      searchUserScale,
      searchTableColumns,
      searchData,

      //
      pieScale,
      pieData,
      sourceData,
      pieStyle: {
        stroke: '#fff',
        lineWidth: 1
      }
    }
  },
  created () {
    this.roleLimit()
    this.loadSellData()
    this.loadPurchaseData()
    setTimeout(() => {
      this.loading = !this.loading
    }, 1000)
    this.loadSellBarData()
    this.loadVehicleNumBarData()
    this.loadPortSellData()
    this.loadPurchaseMaterielData()
  },
  methods: {
    moment,
    roleLimit () {
      new Promise(resolve => {
        const data = roleLimit().then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        if (res == 4) {
          this.roleLimitre = false
        } else {
          this.roleLimitre = true
        }
      })
    },
    onChanged (date, dateString) {
      console.log('日期change:' + date, dateString)
      // 1. 读取选择的销售数据
      new Promise(resolve => {
        const data = getSellData({ params: dateString }).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        if (res.sellPredictQuantity < 0) {
          this.sellPredictQuantity = 0
        } else {
          this.sellPredictQuantity = res.sellPredictQuantity
        }
        if (res.todaySellPredictQuantity < 0) {
          this.todaySellPredictQuantity = 0
        } else {
          this.todaySellPredictQuantity = res.todaySellPredictQuantity
        }

        if (res.sellQuantity < 0) {
          this.sellQuantity = 0
        } else {
          this.sellQuantity = res.sellQuantity
        }
        if (res.todaySellQuantity < 0) {
          this.todaySellQuantity = 0
        } else {
          this.todaySellQuantity = res.todaySellQuantity
        }
      })

      // 2. 各个料口当日的出库量
      this.portData = []
      new Promise(resolve => {
        const data = getPortSellBar({ params: dateString }).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        if (JSON.stringify(res.portSellBar) == '{}') {
          // 如果发货料口数据为空，添加部分示例数据
          this.portData.push({ name: '(当日尚无数据)', value: 0 })
          this.portData.push({ name: '', value: 0 })
          this.portData.push({ name: '', value: 0 })
          this.portData.push({ name: '', value: 0 })
        } else {
          for (var p in res.portSellBar) {
            var portSell = res.portSellBar[p]
            if (portSell < 0) {
              portSell = 0
            }
            this.portData.push({
              name: p,
              value: portSell
            })
          }
        }
      })
    },
    loadSellBarData () {
      new Promise(resolve => {
        const data = getSellBar({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        if (JSON.stringify(res.sellBar) == '{}') {

        } else {
          for (var p in res.sellBar) {
            var sellNum = res.sellBar[p]
            if (sellNum < 0) {
              sellNum = 0
            }
            this.data.push({
              name: p,
              value: sellNum
            })
          }
        }
      })
    },
    loadPurchaseMaterielData () {
      new Promise(resolve => {
        const data = getTodayPurchaseBar({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        // 如果采购数据为空，添加示例数据
        if (JSON.stringify(res.materielPurchaseBar) == '{}') {
          this.purchaseData.push({ name: '燃煤炉渣(铝制)', value: 478.55 })
          this.purchaseData.push({ name: '磷石膏', value: 144.72 })
          this.purchaseData.push({ name: '燃煤炉渣', value: 290.01 })
          this.purchaseData.push({ name: '无烟煤', value: 182.41 })
        } else {
          for (var p in res.materielPurchaseBar) {
            var purchaseNum = res.materielPurchaseBar[p]
            if (purchaseNum < 0) {
              purchaseNum = 0
            }
            this.purchaseData.push({
              name: p,
              value: purchaseNum
            })
          }
        }
      })
    },
    loadVehicleNumBarData () {
      new Promise(resolve => {
        const data = getVehicleNumBar({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        for (var p in res.monthVehicleNum) {
          this.vechileNumData.push({
            name: p,
            value: res.monthVehicleNum[p]
          })
        }
      })
    },
    loadSellData () {
      new Promise(resolve => {
        const data = getSellData({ params: '' }).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        if (res.sellPredictQuantity < 0) {
          this.sellPredictQuantity = 0
        } else {
          this.sellPredictQuantity = res.sellPredictQuantity
        }
        if (res.todaySellPredictQuantity < 0) {
          this.todaySellPredictQuantity = 0
        } else {
          this.todaySellPredictQuantity = res.todaySellPredictQuantity
        }

        if (res.sellQuantity < 0) {
          this.sellQuantity = 0
        } else {
          this.sellQuantity = res.sellQuantity
        }
        if (res.todaySellQuantity < 0) {
          this.todaySellQuantity = 0
        } else {
          this.todaySellQuantity = res.todaySellQuantity
        }
      })
    },
    loadPurchaseData () {
      new Promise(resolve => {
        const data = getPurchaseData({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        if (res.purchaseQuantity < 0) {
          this.purchaseQuantity = 0
        } else {
          this.purchaseQuantity = res.purchaseQuantity
        }
        if (res.todayPurchaseQuantity < 0) {
          this.todayPurchaseQuantity = 0
        } else {
          this.todayPurchaseQuantity = res.todayPurchaseQuantity
        }
      })
    },
    loadPortSellData () {
      new Promise(resolve => {
        const data = getPortSellBar({ params: '' }).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        if (JSON.stringify(res.portSellBar) == '{}') {
          // 如果发货料口数据为空，添加部分示例数据
          this.portData.push({ name: '(当日尚无数据)', value: 0 })
          this.portData.push({ name: '', value: 0 })
          this.portData.push({ name: '', value: 0 })
          this.portData.push({ name: '', value: 0 })
        } else {
          for (var p in res.portSellBar) {
            var portSell = res.portSellBar[p]
            if (portSell < 0) {
              portSell = 0
            }
            this.portData.push({
              name: p,
              value: portSell
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.extra-wrapper {
  line-height: 55px;
  padding-right: 24px;

  .extra-item {
    display: inline-block;
    margin-right: 24px;

    a {
      margin-left: 24px;
    }
  }
}

.antd-pro-pages-dashboard-analysis-twoColLayout {
  position: relative;
  display: flex;
  display: block;
  flex-flow: row wrap;

  &.desktop div[class^='ant-col']:last-child {
    position: absolute;
    right: 0;
    height: 100%;
  }
}

.antd-pro-pages-dashboard-analysis-salesCard {
  height: calc(100% - 24px);
  /deep/ .ant-card-head {
    position: relative;
  }
}

.dashboard-analysis-iconGroup {
  i {
    margin-left: 16px;
    color: rgba(0, 0, 0, 0.45);
    cursor: pointer;
    transition: color 0.32s;
    color: black;
  }
}
.analysis-salesTypeRadio {
  position: absolute;
  right: 54px;
  bottom: 12px;
}
</style>
